import * as React from 'react';
import { observer } from 'mobx-react';
import { inject } from '../utils';
import { withTheme } from 'styled-components';
import Badge from './Badge';
import Translate, { translate } from './Translate';
import Icon from './Icon';
import { AccessibilityStore, TranslationStore } from '../stores';
import { Theme } from '../models/Theme';
import HeaderButton from './HeaderButton';
import { ToggleFiltersOptions } from '../models/configuration/header/ToggleFilters';

interface FiltersToggleProps extends ToggleFiltersOptions {
    theme?: Theme;
    translationStore?: TranslationStore;
    accessibilityStore?: AccessibilityStore;
    onClick: () => void;
    filtersActive?: boolean;
    filtersCount?: number;
    expanded?: boolean;
}

@inject('accessibilityStore', 'translationStore')
@observer
class FiltersToggle extends React.Component<FiltersToggleProps> {
    render() {
        const {
            theme,
            translationStore,
            accessibilityStore,
            onClick,
            filtersActive,
            filtersCount,
            expanded,
            icon = { filename: 'MenuIcon', hide: false },
            label = 'Filters',
            showCount = false,
        } = this.props;

        return (
            <HeaderButton
                aria-label={accessibilityStore.buttonAccessibilityValue(
                    'FiltersToggleButton'
                )}
                title={translate(translationStore, 'Filters')}
                onClick={onClick}
                data-metric-id={'filterToggle-button'}
                aria-expanded={expanded}
                aria-controls={'filters-mask'}
                {...theme.FiltersToggleButton}
            >
                <Icon
                    hide={icon.hide}
                    fileName={icon.filename}
                    height="1.4em"
                    width="1.4em"
                    margin="0 0.5em 0 0"
                    {...theme.FiltersToggleButtonIcon}
                />
                <Translate>{label}</Translate>
                {showCount && filtersActive && (
                    <Badge
                        marginX="sm"
                        bgColor="primary"
                        {...theme.FiltersToggleBadge}
                    >
                        {filtersCount}
                    </Badge>
                )}
            </HeaderButton>
        );
    }
}

export default withTheme(FiltersToggle) as any;



// WEBPACK FOOTER //
// ./src/Components/FiltersToggle.tsx